// src/constants/menu/controlMenu.ts
import { SidebarNavigationItem } from '@app/components/layouts/main/sider/sidebarNavigation';
import { RootState } from '@app/store/store';
import { BaseImage } from '@app/components/common/BaseImage/BaseImage';
import UserManagementIcon from "assets/menus/master-maintenance/user-management-1.svg";
import SelectedUserManagementIcon from "assets/menus/master-maintenance/user-management.svg";
import { REPORT_MENU } from '@app/constants/menu/reportMenu';
import ReportingMenuIcon from "assets/menus/master-maintenance/business-intelligence-management-1.svg";
import SelectedReportingMenuIcon from "assets/menus/master-maintenance/business-intelligence-management.svg";
import ItemSettingsIcon from "assets/menus/master-maintenance/item-settings-1.svg";
import SelectedItemSettingsIcon from "assets/menus/master-maintenance/item-settings.svg";
import { canAccess } from '@app/utils/permissionUtils';
export const CONTROL_MENU = (state: RootState): SidebarNavigationItem[] => [
  ...REPORT_MENU(state),
  {
    title: 'shortcutMenus.manageAgent.title',
    key: 'manageAgent',
    icon: <BaseImage src={UserManagementIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedUserManagementIcon} preview={false} />,
    url: '/shortcut/manage-agent',
    show: !!canAccess(state, 'admin.manage.distributors') || !!canAccess(state, 'admin.manage.sales-agents') || !!canAccess(state, 'admin.manage.online-marketers')
  },
  {
    title: 'shortcutMenus.userManagement.title',
    key: 'userManagement',
    icon: <BaseImage src={UserManagementIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedUserManagementIcon} preview={false} />,
    url: '/shortcut/user-management',
    show: !!canAccess(state, 'user.management')
  },
  {
    title: 'shortcutMenus.commissionManagement.title',
    key: 'commissionManagement',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/commission-management',
    show:
      !!canAccess(state, 'admin.manage.commission-plans') ||
      !!canAccess(state, 'admin.manage.commission-payouts') 
  },
  {
    title: 'shortcutMenus.itemSettings.title',
    key: 'itemSettings',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/item-settings',
    show: !!canAccess(state, 'itemSettings.management')
  },
  {
    title: 'shortcutMenus.factoryPrinting.title',
    key: 'factoryPrinting',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/factory-printing',
    show: !!canAccess(state, 'factoryPrinting.management')
  },
  {
    title: 'shortcutMenus.adminApproval.title',
    key: 'adminApproval',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/admin-approval',
    show: !!canAccess(state, 'adminApprovalReport.management')
  },
  {
    title: 'shortcutMenus.factoryScanning.title',
    key: 'factoryScanning',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/factory-scanning',
    show: !!canAccess(state, 'factoryScanning.management')
  },
  {
    title: 'shortcutMenus.reportConfiguration.title',
    key: 'reportConfiguration',
    icon: <BaseImage src={ReportingMenuIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedReportingMenuIcon} preview={false} />,
    url: '/shortcut/report-configuration',
    show: !!canAccess(state, 'reportConfigure.management')
  }


];
